export const FETCH_METRIC_REQUEST = "dashboard/FETCH_METRIC_REQUEST";
export const FETCH_METRIC_SUCCESS = "dashboard/FETCH_METRIC_SUCCESS";
export const FETCH_METRIC_FAILURE = "dashboard/FETCH_METRIC_FAILURE";

export const fetchMetricRequest = ({ name, filters }) => ({
  type: FETCH_METRIC_REQUEST,
  payload: { name, filters },
});
export const fetchMetricSuccess = ({ name, filtersKey, data }) => ({
  type: FETCH_METRIC_SUCCESS,
  payload: { name, filtersKey, data },
});
export const fetchMetricFailure = ({ name, error }) => ({
  type: FETCH_METRIC_FAILURE,
  payload: { name, error },
});
